import { FormBuilder, FormShape } from '../types';
import filterObjectByKeys from './filterObjectByKeys';

const getPathForForms = (
	fields: FormShape<FormBuilder>,
	primaryFormName = '',
	parentName = '',
) => {
	const paths = [] as string[];

	Object.keys(fields).forEach((form) => {
		if (form === primaryFormName) {
			paths.push(primaryFormName);
		} else {
			parentName !== ''
				? paths.push(parentName + '.' + form)
				: paths.push(form);
			const nestedFields = filterObjectByKeys(
				fields[form] as FormShape<FormBuilder>,
			);
			if (Object.keys(nestedFields).length > 0) {
				paths.push(...getPathForForms(nestedFields, '', form));
			}
		}
	});
	return paths;
};

export default getPathForForms;
